export const READ_PERMISSION = 1;
export const STORE_PERMISSION = 2;
export const UPDATE_PERMISSION = 3;
export const TOTAL_PERMISSION = 4;